export function extractErrorMessage(error) {
  const defaultErrorMessage = getDefaultErrorMessage();

  if (!error) return defaultErrorMessage;

  // axios response error
  if (error.response) {
    const res = error.response.data;

    if (res?.Error?.Message) {
      return res.Error.Message;
    }

    return defaultErrorMessage;
  }

  return defaultErrorMessage;
}

export function getDefaultErrorMessage() {
  return 'İşlem gerçekleştirilirken bir hata oluştu!';
}
